<app-notification-bell
    cdkOverlayOrigin
    [active]="overlayIsOpen"
    (click)="toggleOverlay()"
    clickTracking
    [trackingCategory]="TrackingCategory.notification"
    [trackingArea]="NotificationArea.header"
    [trackingAction]="NotificationAction.notificationsClicked"
></app-notification-bell>

<ng-template
    cdkConnectedOverlay
    cdkConnectedOverlayGrowAfterOpen
    [cdkConnectedOverlayOpen]="overlayIsOpen"
    [cdkConnectedOverlayOrigin]="overlayOrigin"
    [cdkConnectedOverlayPositions]="overlayPositions"
>
    <div *ngIf="overlayIsOpen" @overlayTrigger class="notification-overly">
        <div
            #overlayHeader
            class="notification-overly__header"
            [class.is-loading]="loading$ | async"
        >
            <h3 class="notification-overly__title" translate>Notifications</h3>
            <a
                routerLink="/settings/notification-settings"
                aria-label="Notification Settings"
                clickTracking
                trackingCategory="TrackingCategory.notification"
                trackingArea="NotificationArea.overlay"
                trackingAction="NotificationAction.settingsClicked"
            >
                <translate>Go to settings</translate>
            </a>
        </div>

        <div
            class="notification-overlay__content scrollbar"
            appIntersectionContext
            intersectionRootMargin="0px"
            [intersectionThreshold]="1"
        >
            <app-system-response
                *ngIf="error$ | async; else notifications"
                responseType="error"
                title="NotificationLoadingErrorTitle"
                message="NotificationLoadingErrorMessage"
                size="small"
            />
            <ng-template #notifications>
                @if (notificationsLoading$ | async) {
                    <app-notification-list
                        [notifications]="[]"
                        [showSkeletons]="true"
                    >
                    </app-notification-list>
                } @else {
                    @for (chunk of chunks$ | async; track $index) {
                        @if (chunk.notifications.length > 0) {
                            @if (!$first) {
                                <div
                                    class="px-6 py-2 bg-accent-extra-light text-accent-medium text-caption accent-light-bottom-border"
                                >
                                    <translate>{{ chunk.label }}</translate>
                                    @if (chunk.showDate) {
                                        {{
                                            chunk.date
                                                | dateInDefaultTimezone
                                                    : 'D MMMM'
                                        }}
                                    }
                                </div>
                            }
                            <app-notification-list
                                [notifications]="chunk.notifications"
                            ></app-notification-list>
                        }
                    }
                }
            </ng-template>
        </div>
        <div
            class="flex items-center justify-between px-6 py-4 accent-light-top-border"
        >
            <a
                [routerLink]=""
                *ngIf="(notifications$ | async)?.length"
                aria-label="Mark all as read"
                clickTracking
                [class.disabled]="allRead$ | async"
                [trackingCategory]="TrackingCategory.notification"
                [trackingArea]="NotificationArea.overlay"
                [trackingAction]="NotificationAction.markAllAsReadClicked"
                (click)="markAllAsRead($event)"
            >
                <translate>Mark all as read</translate>
            </a>
            <app-button
                *ngIf="(notifications$ | async)?.length"
                routerLink="/notifications"
                class="notification-overlay__show-all"
                buttonType="flat-primary"
                [trackingData]="{
                    category: TrackingCategory.notification,
                    area: NotificationArea.overlay,
                    action: NotificationAction.notificationShowAllButton,
                }"
            >
                <translate>See all notifications</translate>
            </app-button>
        </div>
    </div>
</ng-template>
